import { APP_PRODUCT } from 'constants/app-config'

export const IS_APP_PRODUCT_GETUNIQ = APP_PRODUCT === 'getuniq'
export const IS_APP_PRODUCT_ADSIMPLE = APP_PRODUCT === 'adsimple'
